var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeprotector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 31.8537H13.5L35.7744 14.7616C38.6619 12.5459 42.6812 12.5586 45.5547 14.7925L67.5 31.8537Z",
    fill: "#B31B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 31.8537H67.5M13.5 31.8537L35.7744 14.7616C38.6619 12.5459 42.6812 12.5586 45.5547 14.7925L67.5 31.8537M13.5 31.8537V60C13.5 64.4183 17.0817 68 21.5 68H32.5588M67.5 31.8537V60C67.5 64.4183 63.9183 68 59.5 68H57.5C53.0817 68 49.5 64.4183 49.5 60V57.5793C49.5 53.161 45.9183 49.5793 41.5 49.5793H40.5588C36.1406 49.5793 32.5588 53.161 32.5588 57.5793V58.2683",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeprotector);
export default __webpack_public_path__ + "static/media/homeprotector.654abfa0ba56148ebfbe6bb42eb38fa8.svg";
export { ForwardRef as ReactComponent };